module.exports = __webpack_public_path__ + "img/consultation_part4.ebaf77b9.png";